<div data-test="vLyurQPw" class="form mb-0">
  <div *ngIf="notes1Control" data-test="wKzc0yWJ" class="form-group">
    <label data-test="IqVVILNu" class="form-group__label" for="input-14">
      {{ label1 }}
      <span data-test="W1dGDrZJ" class="text-light">{{ subLabel1 }}</span>
    </label>
    <div data-test="l31wo9jf" class="textarea-wrap ui-resizable">
      <textarea
        data-test="HJ_RdM5P"
        class="input"
        id="input-14"
        placeholder="Notes..."
        rows="3"
        mdAutosize
        [ngrxFormControlState]="notes1Control"
      ></textarea>
      <div data-test="gV6PHlUZ" class="corner icon link-light">
        <svg data-test="MaHGhVKp" class="icon__icon-resize" width="8px" height="8px">
          <use xlink:href="#icon-resize"></use>
        </svg>
      </div>
    </div>
  </div>

  <div *ngIf="notes2Control" data-test="yW9HCavq" class="form-group">
    <label data-test="-WCoz70G" class="form-group__label" for="input-14">
      {{ label2 }}
      <span data-test="UYjpTigR" class="text-light">{{ subLabel2 }}</span>
    </label>
    <div data-test="UWon3toe" class="textarea-wrap ui-resizable">
      <textarea
        data-test="bkvL68xm"
        class="input"
        id="input-14"
        placeholder="Notes..."
        rows="3"
        mdAutosize
        [ngrxFormControlState]="notes2Control"
      ></textarea>
      <div data-test="K7UnpVhH" class="corner icon link-light">
        <svg data-test="-DhTYmwT" class="icon__icon-resize" width="8px" height="8px">
          <use xlink:href="#icon-resize"></use>
        </svg>
      </div>
    </div>
  </div>

  <ng-content></ng-content>
</div>
